import { TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useRef, useState } from 'react';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from '../api';
import CloseImage from '../../assets/ic_close.png';
import ImageUploader from 'react-images-upload';
import { format } from 'date-fns';
import editProf from '../../assets/editProf.png';
import CustomDate from '../components/customDate';
import CustomTextField from '../components/customTextField';

export default function EditMediaDisplay(props) {
    const [ID, setID] = useState("")
    const [title, setTitle] = useState("")
    const [url, setUrl] = useState("")
    const listMedia = [
        { value: 'video', id: 0 },
        { value: 'image', id: 1 },
    ]
    const [media, setMedia] = useState(null)
    const [mediaID, setMediaID] = useState(null)
    const [validTo, setValidTo] = React.useState(null);
    const [validFrom, setValidFrom] = React.useState(new Date());
    const listPublish = [
        { value: 'Ya', id: 1 },
        { value: 'Tidak', id: 0 },
    ]
    const [isPublish, setPublish] = useState(listPublish[0])

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const [visibleImage, setVisibleImage] = React.useState(false);
    const [visibleSeeDetailImage, setVisibleSeeDetailImage] = React.useState(false);
    const [pictures, setPicture] = useState([])
    const [photo, setPhoto] = useState("")
    const [namaPicture, setnamaPicture] = useState([])

    const [errorTitle, setErrorTitle] = React.useState(false);
    const [texterrorTitle, setTextErrorTitle] = React.useState(null);
    const [errorFrom, setErrorFrom] = React.useState(false);
    const [texterrorFrom, setTextErrorFrom] = React.useState(null);
    const [errorTo, setErrorTo] = React.useState(false);
    const [texterrorTo, setTextErrorTo] = React.useState(null);
    const [errorTipe, setErrorTipe] = React.useState(false);
    const [texterrorTipe, setTextErrorTipe] = React.useState(null);
    const [errorFoto, setErrorFoto] = React.useState(false);
    const [texterrorFoto, setTextErrorFoto] = React.useState(null);
    const [errorVideo, setErrorVideo] = React.useState(false);
    const [texterrorVideo, setTextErrorVideo] = React.useState(null);

    useEffect(() => {
        getDetail()
    }, [])

    const getDetail = (cat) => {
        api.create().getDetailMedia(props.id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setID(data.id)
                    setTitle(data.title)
                    let index = listMedia.findIndex((val) => val.value === data.media_type)
                    if (index > -1) {
                        setMedia(listMedia[index])
                    }
                    setPhoto(data.image_url === "" ? "" : data.image_url)
                    setUrl(data.video_url === "" ? "" : data.video_url)
                    setValidTo(new Date(data.expired_date))
                    setValidFrom(new Date(data.effective_date))
                    let idx = listPublish.findIndex((val) => val.id === data.is_publish)
                    if (idx > -1) {
                        setPublish(listPublish[idx])
                    }
                    forceUpdate()
                }
            }
        })
    }

    const handleSave = () => {
        let id;
        let photo = pictures[0]

        if (title === "") {
            setErrorTitle(true)
            setTextErrorTitle("Nama wajib diisi")
        } else if (validFrom === null) {
            setErrorFrom(true)
            setTextErrorFrom("Valid From wajib diisi")
        } else if (validTo === null) {
            setErrorTo(true)
            setTextErrorTo("Valid To wajib diisi")
        } else if (media === null) {
            setErrorTipe(true)
            setTextErrorTipe("Tipe wajib diisi")
        } else if (media && media.id === 0 && url === "") {
            setErrorVideo(true)
            setTextErrorVideo("URL wajib diisi")
        } else if (media && media.id === 1 && photo === undefined) {
            setErrorFoto(true)
            setTextErrorFoto("Foto wajib diisi")
        } else {
            let formData = new FormData()
            formData.append('media_promotion_id', ID)
            formData.append('title', title)
            formData.append('video_url', url)
            if (photo !== undefined) {
                formData.append('image_file', photo)
            }
            formData.append('effective_date', format(new Date(validFrom), 'yyyy-MM-dd'))
            formData.append('expired_date', format(new Date(validTo), 'yyyy-MM-dd'))
            formData.append('is_publish', isPublish.id)
            console.log(...formData);

            props.updateMedia(formData)

            // api.create().createMedia(formData).then(response => {
            //     console.log(response);
            //     if (response.data) {
            //         if (response.data.status === true) {
            //             history.goBack()
            //         }
            //     }
            // })
        }

    }

    const onDrop = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs);
        setPhoto(pictureDataURLs)
        setPicture(pictureFiles)
        setnamaPicture(pictureFiles[0].name)
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit TV Media Display</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div style={{ marginTop: 20 }}>
                            <CustomTextField
                                required={true}
                                label={'Nama'}
                                value={title}
                                error={errorTitle}
                                helperText={texterrorTitle}
                                onChange={(val) => {
                                    setTitle(val)
                                    setErrorTitle(false)
                                    setTextErrorTitle("")
                                    forceUpdate()
                                }}
                            />
                        </div>
                        <Autocomplete
                            options={listMedia}
                            getOptionLabel={(option) => option.value}
                            debug
                            style={{ width: '100%', marginTop: 24 }}
                            onChange={(event, newInputValue) => {
                                setMedia(newInputValue)
                                setErrorTipe(false)
                                setTextErrorTipe("")
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    error={errorTipe}
                                    helperText={texterrorTipe}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    placeholder="Select Video/Foto"
                                    label='Tipe'
                                />
                            }
                            value={media}
                        />

                        {media ?
                            media.id === 1 ?
                                <div style={{ marginTop: 12 }}>
                                    <CustomTextField
                                        label={'Foto'}
                                        value={"Lihat Detail"}
                                        error={errorFoto}
                                        helperText={texterrorFoto}
                                        onClick={() => {
                                            setVisibleSeeDetailImage(true)
                                            setErrorFoto(false)
                                            setTextErrorFoto("")
                                        }}
                                    />
                                </div>
                                :
                                <div style={{ marginTop: 12 }}>
                                    <CustomTextField
                                        label={'URL'}
                                        value={url}
                                        error={errorVideo}
                                        helperText={texterrorVideo}
                                        onChange={(val) => {
                                            setUrl(val)
                                            setErrorVideo(false)
                                            setTextErrorVideo("")
                                            forceUpdate()
                                        }}
                                    />
                                </div>
                            :
                            null
                        }

                    </div>
                    <div className="column-2">

                        <div style={{ marginTop: 3 }}>
                            <CustomDate
                                label={"Valid From"}
                                value={validFrom}
                                setValue={(date) => {
                                    setValidFrom(date)
                                    setErrorFrom(false)
                                    setTextErrorFrom("")
                                    forceUpdate()
                                }}
                            />
                        </div>

                        <div style={{ marginTop: 2 }}>
                            <CustomDate
                                label={"Valid To"}
                                value={validTo}
                                minDate={validFrom && validFrom}
                                setValue={(date) => {
                                    setValidTo(date)
                                    setErrorTo(false)
                                    setTextErrorTo("")
                                    forceUpdate()
                                }}
                            />
                        </div>

                        <Autocomplete
                            options={listPublish}
                            getOptionLabel={(option) => option.value}
                            disableClearable
                            style={{ width: '100%' }}
                            onChange={(event, newInputValue) => {
                                setPublish(newInputValue)
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13, padding: '3px 0' } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label={'Publish'}
                                />
                            }
                            value={isPublish}
                        />

                    </div>
                </div>

                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleSave()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>

            </div>
            {visibleImage && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleImage(false)
                                        setPicture("")
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <ImageUploader
                            withIcon={true}
                            withPreview
                            buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                            buttonText={'Select Picture'}
                            onChange={onDrop}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                            maxFileSize={1000000}
                            label={"Max file size: 1 Mb, Require pixel: 550 X 290 pixel, accepted: jpg or png"}
                        />
                        {pictures.length > 0 ?
                            <div style={{ display: 'grid', margin: 20 }}>
                                <div style={{ justifySelf: 'center' }}>
                                    <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => setVisibleImage(false)}>Upload</span>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}

            {
                visibleSeeDetailImage ?
                    <div className="App app-popup-show">
                        <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                            <div style={{ margin: 'auto', width: 90, height: 90, backgroundColor: 'transparent', marginTop: 20, borderRadius: 50 }}>
                                <img style={{ width: 88, height: 90 }} src={photo} />
                                <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer', backgroundColor: 'gray' }}
                                    onClick={(e) => {
                                        // setPicture("")
                                        // setUploadVisible(true)
                                        setVisibleImage(true)
                                        setPicture("")
                                    }}
                                />
                            </div>
                            <div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                                <div onClick={() => setVisibleSeeDetailImage(false)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }
        </div>
    )
}
